const getSettlementDetails = (uuid, settlements) =>
  settlements.find(({ uuid: settlementUuid }) => settlementUuid === uuid);

export { getSettlementDetails };
